import React from "react";
import { Box, InputBase, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  labelContainer: {
    marginBottom: "1.2rem",
  },

  label: {
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.1rem",
  },
}));

const Label = ({ label }) => {
  const classes = useStyles();

  return (
    <Box className={classes.labelContainer}>
      <Typography className={classes.label}>{label}</Typography>
    </Box>
  );
};

export default Label;
